(function ($) {
	'use strict';

	let currentPage = 1;

	$(document).ready(async function () {
		try {
			const categoryItems = $('.category-item');
			const dataPromises = [];

			categoryItems.each(async function () {
				const termId = $(this).data('term-id');

				// Make the data request using termId
				const dataPromise = dataRequest(termId);
				dataPromises.push(dataPromise);
			});

			// Wait for all data requests to resolve
			const dataArray = await Promise.all(dataPromises);

			// Process the fetched data and append cards
			dataArray.forEach((data, index) => {
				const termId = categoryItems.eq(index).data('term-id');

				if (data && data.posts.length !== 0) {
					appendMediaWallCards(data.posts, termId);
				} else {
					$(`#inspiration-content-${termId}`).append('<p>No results found</p>');
				}
			});

			// Initialize Slick slider after appending cards
			initSlickSlider();
		} catch (error) {
			console.error('Error:', error);
		}
	});

	async function dataRequest(groupID, pageNumber = 1, postsPerPage = 10) {
		try {
			const params = new URLSearchParams({
				action: 'fetch_posts_data',
				term_id: groupID,
				page_number: pageNumber,
				posts_per_page: postsPerPage,
			});

			const response = await fetch(ajax_object.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body: params,
			});

			if (!response.ok) {
				throw new Error('Network response was not ok ' + response.statusText);
			}

			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error:', error);
		}
	}

	function stripHtmlTags(input) {
		return input.replace(/<\/?[^>]+(>|$)/g, '');
	}

	function getIframeSrc(htmlString) {
		const regex = /src="([^"]+)"/;
		const match = htmlString.match(regex);

		if (match && match[1]) {
			return match[1];
		} else {
			return 'No src attribute found';
		}
	}
	// ******** Cards *******
	const createSlidesHTML = (postImages) => {
		return postImages
			.map((dataObject, index) => {
				return `<div class="slide">
						  <img src="${dataObject.idea_image.url}" alt="Slide ${index + 1}">
						</div>`;
			})
			.join('');
	};

	function createAssocProdsHTML(dataArray) {
		const divs = dataArray
			.map((item) => {
				return `
					<div class="product-item-container">
						<div class="product-item">
							<div class="image">
								<img src="${item.img[0].product_color_variation_image.url}" alt="${item.img[0].product_color_variation_image.alt}">
							</div>
							<div class="copy">
								<p>${item.title}</p>
								<div class="gift_guide_product_desc d-none mt-1">${item.description}</div>
								<a href="${item.url}"><button class="compare-link">Learn More</button></a>
							</div>
						</div>
					</div>
				`;
			})
			.join('');

		return `
				<div class="inspiration-related-products-container"> 
					<p>Explore related products</p>
					<div class="inspiration-related-products">
						${divs}
					</div> 
				</div>
			`;
	}

	function createAssocCatsHTML(dataArray) {
		return dataArray
			.map((item) => {
				return `
					<div class="category-item-container">
						<a href="${siteUrl}/inspiration-categories-group/${item.slug}">
							<div data-name="${item.slug}" data-categoryid="${item.term_id}" class="category-item">
								${item.name}
							</div>
						</a>
					</div>
				`;
			})
			.join('');
	}

	function createCardHTML(
		index,
		{
			postTitle,
			postTitleModal,
			postText,
			postMediaType,
			postImage,
			postImages,
			postVideo,
			postLikes,
			postComments,
			postLinkUrl,
			postLinkText,
			associatedProducts,
			associatedCategories,
			postType,
			videoType,
			isGiftGuide,
		}
	) {
		const cardColors = ['#9DEDE5', '#FF6542', '#F266BF', '#BEB5FF', '#FFCD57'];
		const cardColor = isGiftGuide ? '#002e23' : cardColors[Math.floor(Math.random() * cardColors.length)];

		const associatedProductsDiv =
			associatedProducts && associatedProducts.length > 0 ? createAssocProdsHTML(associatedProducts) : '';
		const associatedCategoriesDiv =
			associatedCategories && associatedCategories.length > 0 ? createAssocCatsHTML(associatedCategories) : '';
		const imgElement = `<img class="inspiration-card-img ${
			postMediaType === 'video' || postMediaType === 'carousel' ? 'hide-in-modal' : ''
		}" src="${postImage}"/>`; //If post is a video or carousel don't setup image
		let videoElement = postVideo
			? `<iframe class="inspiration-video" height="580px" width="100%" src="${postVideo}" frameborder="0"></iframe>`
			: '';
		if (videoType === 'wordpress') {
			videoElement = `<video class="inspiration-video" height="580px" width="100%" controls><source src="${postVideo}" type="video/mp4"></video>`;
		}
		const carouselElement =
			postMediaType === 'carousel'
				? `<div class="card-carousel card-carousel-${index}">${createSlidesHTML(postImages)}</div>`
				: '';
		const likesDiv = '';
		const renderGiftGuideContent = function (isGiftGuide, associatedProductsDiv) {
			return isGiftGuide
				? `
				  <a href="${postLinkUrl}"><div class="btn_article">Read Full Article</div></a>
				  ${associatedProductsDiv}
				   <a href="${postLinkUrl}"><div class="btn_article">Read Full Article</div></a>
				`
				: ''; // Return empty string if isGiftGuide is false
		};

		// Now, call the renderGiftGuideContent function within the `postText` section of the card.
		const giftGuideContent = renderGiftGuideContent(isGiftGuide, associatedProductsDiv);

		// const likesDiv = (postLikes && postLikes !== '0') ? `<div class="inspiration-card-likes"><sup class="heart">&#9825;</sup> ${postLikes} likes </div>` : '';
		console.log(isGiftGuide);
		return `
				<div class="slide">
					<div data-card-index="${index}" class="inspiration-card-container slide ${postType}" style="background-color:${cardColor};">
	
						<div class="inspiration-img-container ${postMediaType}">
							${postMediaType === 'video' ? '<div class="play-icon hide-in-modal"></div>' : ''}
							<div class="hover-overlay hide-in-modal hide-on-wall"></div>
							${imgElement}
							${videoElement}
							${carouselElement}
						</div> 
	
						<div class="hover-categories hide-in-modal hide-on-wall">${associatedCategoriesDiv}</div>
						<div class="inspiration-card-copy">
							<div class="inspiration-card-copy-top">
								<div class="inspiration-source"> <a href="${postLinkUrl}" target="_blank"><i class="icon-${postType}" ></i> ${postLinkText} </a> </div>
								<div data-btn-index="${index}" class="btn-close hide"></div>
							</div> 
							<div class="inspiration-card-copy-bottom" style="background-color:${cardColor};">
								${postType === 'social_media' ? '' : `<div class="inspiration-card-header show-on-wall">${postTitle}</div>`}
								<div class="inspiration-card-header hide-on-wall">${postTitleModal}</div>
								<div class="inspiration-card-text ${isGiftGuide ? 'gift-guide-card' : ''}">
								${postText}
								${giftGuideContent}
								</div>
								${likesDiv}
								<div class="inspiration-bottom-start-copy">
								${isGiftGuide ? '' : associatedProductsDiv} 
								<div class="inspiration-related-categories-container"> 
									<p>Explore related categories</p>
									<div class="inspiration-related-categories">
										${associatedCategoriesDiv}
									</div> 
								</div>
								<div class="inspiration-links ${isGiftGuide ? 'gift-guide-links' : ''}">
									${
										postType === 'social_media'
											? `<div><a href="${postLinkUrl}" target="_blank"><i class="view"></i> View post </a></div>`
											: ''
									}
									${isGiftGuide ? `<div><a href="${siteUrl}/gift-guide" target="_blank"><i class="view"></i> View post </a></div>` : ''}
									<div ${
										postType !== 'social_media' ? "style='border-right: none;'" : ''
									} class="share-button"> <a href="${postLinkUrl}" target="_blank"><i class="share"></i> Share</a> </div>
								</div>
						   </div>
								<div class="view-arrow hide-on-wall hide-in-modal">View</div>
							</div>
						</div>
					</div>
				</div>`;
	}

	// ******** Data Adapters *******
	// Functions to handle converting the different data shapes from the various endpoints into objects that will work on the front end.
	const givesquadDataAdapter = function (post) {
		const postTitle = post.acf_fields.influencer_name;
		const postTitleModal = post.acf_fields.influencer_name + ': ' + post.acf_fields.influencer_short_description;
		const postText = post.acf_fields.influencer_long_description;
		const postMediaType = 'video';
		const postImage = post.acf_fields.influencer_carousel_image.url; //Swap this with new image for videos
		const postVideo = getIframeSrc(post.acf_fields.influencer_video);
		// need influencer quote
		const postComments = '';
		const postLikes = '';
		const postLinkUrl = post.link || '';
		const postLinkText = 'instaxus.com';
		const postType = post.post_type;
		return {
			postTitle,
			postTitleModal,
			postText,
			postMediaType,
			postImage,
			postImages: null,
			postVideo,
			postLikes,
			postComments,
			postLinkUrl,
			postLinkText,
			postType,
		};
	};

	const ideasDataAdapter = function (post) {
		const isGiftGuide = post.acf_fields.gift_guide_post;
		const postTitle = post.acf_fields.idea_title;
		const postTitleModal = post.acf_fields.idea_title;
		const postText = isGiftGuide ? post.acf_fields.idea_description : stripHtmlTags(post.acf_fields.idea_description);
		const postMediaType = post.acf_fields.idea_images.length > 1 ? 'carousel' : 'image';
		const postImages = post.acf_fields.idea_images;
		const postImage = post.acf_fields.idea_images[0].idea_image.url;
		const postComments = '';
		const postLikes = '';
		const postLinkUrl = post.link || '';
		const postLinkText = 'instaxus.com';
		const postType = post.post_type;
		return {
			postTitle,
			postTitleModal,
			postText,
			postMediaType,
			postImage,
			postImages,
			postLikes,
			postComments,
			postLinkUrl,
			postLinkText,
			postType,
			isGiftGuide,
		};
	};

	const socialMediaDataAdapter = function (post) {
		const postTitle = post.acf_fields.username;
		const postTitleModal = post.acf_fields.username;
		const postText = post.acf_fields.text_plain;
		const postMediaType = post.acf_fields.post_type;
		const postImage =
			post.acf_fields.images && post.acf_fields.images[0] ? post.acf_fields.images[0].image.image_url : '';
		const postVideo = post.acf_fields.video_type && post.acf_fields.video_url ? post.acf_fields.video_url : '';
		const postComments = post.acf_fields.comments;
		const postLikes = post.acf_fields.likes;
		const postLinkUrl = post.acf_fields.source_url;
		const postLinkText = `@${post.acf_fields.username}`;
		const postType = post.post_type;
		const videoType = post.acf_fields.video_type;
		return {
			postTitle,
			postTitleModal,
			postText,
			postMediaType,
			postImage,
			postImages: null,
			postVideo,
			postLikes,
			postComments,
			postLinkUrl,
			postLinkText,
			postType,
			videoType,
		};
	};

	// Functions to handle converting the different data shapes from the various endpoints into objects that will work on the front end.
	const dataConverters = {
		give_squad: givesquadDataAdapter, //Handle posts for givesquad
		ideas: ideasDataAdapter, //Handle posts for ideas
		social_media: socialMediaDataAdapter, //Handle posts for IG
	};

	function appendMediaWallCards(dataArray, termId) {
		const $inspirationContent = $(`#inspiration-content-${termId}`);
		const fragment = document.createDocumentFragment();

		dataArray.forEach((post, index) => {
			const dataConverterFunction = dataConverters[post.post_type];
			const convertedPostData = {
				...dataConverterFunction(post),
				associatedProducts: post.associated_products_data,
				associatedCategories: post.acf_fields.associated_categories,
			};
			const cardHTML = createCardHTML(index, convertedPostData);
			const $cardElement = $(cardHTML);
			addCardclickEvents($cardElement);
			fragment.appendChild($cardElement[0]); // Append each card to the fragment
		});

		// Append all cards in one go to the inspiration content container
		$inspirationContent.append(fragment);
	}

	function initializeSlider($element, slidesToShowValue) {
		$element.slick({
			slidesToShow: slidesToShowValue,
			slidesToScroll: 1,
			autoplay: false,
			centerMode: false,
			autoplaySpeed: 2000,
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	}

	function initSlickSlider() {
		const $slider = $('.inspiration-carousel-one-column');
		const $sliderOne = $('.inspiration-carousel-two-column');

		initializeSlider($sliderOne, 2);
		initializeSlider($slider, 4);
	}

	function closeModal() {
		// $("body").css("overflow", "auto");
		$('body').css('overflow', '');
		$('#inspiration-modal-container').addClass('d-none');
		$('#inspiration-slick').slick('unslick');
		$('#inspiration-slick').html(''); //Deletes entire modal on close
	}

	function resetPage(e) {
		currentPage = 1;
		// Reset nav
		$('.inspiration-wall-btn, .inspiration-wall-sub-btn').removeClass('active');
		$(e.target).addClass('active');

		// Clear content
		$('#inspiration-content').html('');
	}

	let isMobile = window.innerWidth < 768;
	let isDragging = true;
	// ********* Modal Click Events *********
	function addCardclickEvents($cardElement) {
		setTimeout(() => {
			$cardElement.on('click', (e) => {
				if (isDragging && !isMobile) {
					e.preventDefault(); // Prevents the click event if dragging is detected
					e.stopPropagation();
					return;
				}
				const $clickedCard = $(e.currentTarget);
				const $modalCard = $clickedCard.children('.inspiration-card-container').clone();

				// $('html, body').scrollTop(0); // Scroll to top of the page
				//$('body').css('overflow', 'hidden');
				$('#inspiration-modal-container').removeClass('d-none'); // Show modal

				// Clear previous content in the modal and append the clicked card's content
				$('#inspiration-slick').empty().append($modalCard);

				// Reset the src attribute to reload the iframe and stop the video
				$('#inspiration-slick').on('afterChange', function (event, slick, currentSlide) {
					var previousSlide = $(slick.$slides[previousSlideIndex]);
					var previousIframe = previousSlide.find('iframe');
					var previousVideo = previousSlide.find('video');

					// If it's an iframe, reset the src attribute to stop the video
					if (previousIframe.length) {
						var iframeSrc = previousIframe.attr('src');
						previousIframe.attr('src', '').attr('src', iframeSrc);
					}

					// If it's a video tag, pause the video
					if (previousVideo.length) {
						previousVideo[0].pause();
					}

					// Update the previousSlideIndex for the next change
					previousSlideIndex = currentSlide;
				});

				// Initialize the modal's slider with the clicked card's content
				$('#inspiration-slick').slick({
					dots: false,
					slidesToShow: 1,
					arrows: true,
					slidesToScroll: 1,
					autoplay: false,
					centerMode: false,
					initialSlide: 0, // You may need to adjust this based on your requirements
				});

				//Once all the wall cards are converted into slides in the modal,
				//some of the cards have an additional slider inside of them.
				//Setup slider for cards that have carousels inside.
				$('#inspiration-modal .card-carousel').each(function () {
					$(this).slick({
						dots: true,
						slidesToShow: 1,
						arrows: true,
						slidesToScroll: 1,
						autoplay: false,
						centerMode: false,
					});
				});

				// Unhide all close buttons on slick slides and set up close button to close the modal when clicked
				$('.slick-slide .btn-close').removeClass('hide');
				$('.slick-slide .btn-close').on('click', closeModal);

				// Setup associated category buttons (if needed)
				$('.slick-slide .category-item').on('click', (event) => {
					closeModal();
					resetPage(event);
					handleDataRequest(event.target.dataset.categoryid);
				});

				// social native mobile
				$('.share-button').on('click', function (e) {
					e.preventDefault(); // Prevents the default action of the <a> tag
					const postLinkUrl = $(this).find('a').attr('href');

					if (navigator.share) {
						const EN = {
							title: 'InstaxUS',
							text: '',
							url: postLinkUrl,
						};
						// navigator.share(lang == 'EN' ? EN : SP)
						navigator
							.share(EN)
							.then(() => console.log('Content shared successfully!'))
							.catch((error) => console.log('Error sharing content:', error));
					} else {
						console.log('Web Share API is not supported in your browser.');
						window.open(postLinkUrl, '_blank');
					}
				});
			});

			var videoStopped = false; // Flag to track if videos have been stopped

			function pauseAllVideos() {
				$('iframe').each(function (index, iframe) {
					try {
						var videoPlayer = iframe.contentWindow;
						if (videoPlayer && typeof videoPlayer.postMessage === 'function') {
							// Send a postMessage command to pause the video
							videoPlayer.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						}
					} catch (error) {
						console.error('Error pausing video:', error);
					}
				});
			}

			// Call the function to pause all videos (you can trigger this based on your requirements)
			pauseAllVideos();
		}, 100);
	}
	let timer = 0;
	$('.inspiration-carousel').on('mousemove', '.slick-track', function (event) {
		isDragging = true;
		clearTimeout(timer);
		timer = setTimeout(() => {
			isDragging = false;
		}, 100);
	});
	console.log('product-inspiration-carousel.js loaded');
})(jQuery);
